import app from 'app';
import TopicsView from 'v/TopicsView';
import EditDateView from 'v/EditDateView';
import ThumbnailPickerView from 'v/ThumbnailPickerView';
import Marionette from 'backbone.marionette';
import StoryboardCategoriesList from './StoryboardCategoriesList.vue';
import CategoriesManager from '../CategoriesManager/CategoriesManager.vue';
import CustomVideoOverlays from './CustomVideoOverlays/CustomVideoOverlays.vue';
import AiPromptsList from '../../components/aiPrompts/AiPromptsList.vue';
import storyViewBus from '../Story/storyViewBus';

app.namespace.View.StoryMetadataView = Marionette.ItemView.extend({
  className: 'wt-story-metadata-editor',
  template: app.compileTemplate.$('#storyMetadataEditor'),
  DISPLAY_STATE: {
    EDITOR: 'editor',
    PRODUCE: 'produce',
  },
  events: {
    'click .js-open-editor': '_showManual',
    'click .storyMetadataEditorModelClose': '_hideMeta',
    'click .storyMetadataEditorModelDone': '_editorApply',
    'click .storyMetadataEditorModelCancel': '_hideMeta',
    'click .js-close-modal': '_hideMeta',
    'click .js-edit-poster': '_dumpVideoPosterModel',
    'change #hide-date': '_changeHideDate',
    'keypress textarea[data-name="description"]': '_limitDescription',
    'visible #storyMetadataEditor-Edit': '_renderPoster',
    'shown.bs.modal': '_modalOnShow',
  },
  initialize: function (options) {
    this.modalCreated = false;
    this.options = options;
    this.controller = options.controller;
    this.viewState = new Backbone.Model({
      displayState: null,
    });

    this._findSelectedCategory();

    this.listenTo(app, 'thumbnailPicker:openFromPreview', () => {
      this.show();
      this.$storyMetadataEditor.removeClass('hide fade'); // ThumbnailPickerView should be visible
      this._dumpVideoPosterModel(null);
    });

    this.listenTo(this.model, 'change:topicId', this._updateCategory);
    this.listenTo(this.model, 'change:template', this._findSelectedCategory);
    this.videoCustomoverlaysUpdates = new Map();
  },

  _onChange: function (e) {
    const $el = $(e.currentTarget);
    const value = $el.val();
    if (value) {
      $el.parent().next('.field-error').hide();
    }
    $el.find('option[selected="selected"]').removeProp('selected');
    $el.find(`option[value="${value}"]`).attr('selected', 'selected');
  },

  _updateCategory: function () {
    this.$('#mainCategory')
      .find('option[value="' + this.model.get('topicId') + '"]')
      .prop('selected', true);
  },
  _changeHideDate: function (e) {
    app.rootStore.commit('user/editorDefault', {
      renderPublishDate: $(e.target).is(':checked'),
    });
  },
  _dumpVideoPosterModel: _.debounce(
    function (e) {
      let returnToMetadata = false;

      if (!_.isEmpty(e)) {
        returnToMetadata = true;
        e.preventDefault();
      }

      if (_.isEmpty(app.rootStore.getters.selectedAssets)) {
        return;
      }

      app.analytics('thumbnailPicker:opened', {
        source: !_.isEmpty(e) ? 'video_info' : 'preview',
      });

      this.editView = new ThumbnailPickerView({
        model: this.videoPosterModelWorkingCopy,
        task: this.model,
        usemodal: false,
        closeModal: this._hideMeta.bind(this),
      });
      console.log('_dumpVideoPosterModel');

      this.$storyMetadataEditorTumbnail.html(this.editView.render().$el).show();
      this.$storyMetadataEditorEditContainer.hide();
      this.editView
        .show()
        .done(
          function () {
            this.model.set('videoPosterSnapshotTime', null);
            // resolved when dialog is confirmed
            if (this.editView.model) {
              this.videoPosterModelWorkingCopy = this.editView.model;
              if (!returnToMetadata) {
                // persist if thumbnail picker shown programmatically
                this.model.videoPosterModel.set(
                  this.videoPosterModelWorkingCopy.attributes
                );
              }
            }
            if (!returnToMetadata) {
              this._hideMeta();
            } else {
              this._renderVideoPosterModel();
              this.$storyMetadataEditorTumbnail.hide();
              this.$storyMetadataEditorEditContainer.show();
            }
          }.bind(this)
        )
        .fail(
          function () {
            if (!returnToMetadata) {
              this._hideMeta();
            } else {
              this.$storyMetadataEditorTumbnail.hide();
              this.$storyMetadataEditorEditContainer.show();
            }
          }.bind(this)
        );
    },
    app.TIME.MENTAL.λ,
    { leading: true, trailing: false }
  ),

  _renderVideoPosterModel: function () {
    if (!this.videoPosterModelWorkingCopy) {
      return;
    }

    const videoPosterModel = this.videoPosterModelWorkingCopy;
    const $img = this.$('.video-poster').find('img');
    const $imgContainer = this.$videoPosterContainer; // $img.parent('#video-poster-warp'),
    let imgSrc = app.DEFAULT.storyThumbnailImage.replace(
      'video-poster-placeholder',
      'video-poster-placeholder_missing'
    );
    let resize = false;

    if (_.isEmpty(videoPosterModel.get('type'))) {
      $img.attr('style', '');
      $imgContainer.attr('style', '');
      $imgContainer.removeClass('hasImage');
    } else {
      $imgContainer.addClass('hasImage');
      imgSrc =
        app.namespace.Controller.AssetController.getVideoPosterUrl(
          videoPosterModel
        );
      resize = true;
    }

    $imgContainer[videoPosterModel.isWEBPAGE() ? 'addClass' : 'removeClass'](
      'webpage-wrapper'
    );
    $img.prop('src', imgSrc);
    $img.attr('id', 'poster-preview');
    $img.attr('data-asset-id', this.videoPosterModelWorkingCopy.get('id'));

    if (resize) {
      this._renderImageContainer();
      const container = {
        width: $imgContainer.width() > 0 ? $imgContainer.width() : 251,
        height: $imgContainer.height() > 30 ? $imgContainer.height() : 164,
      };

      let targetImage = null;
      if (videoPosterModel.isFRAGMENT()) {
        let realImage = new Image();
        realImage.setAttribute('src', imgSrc);
        targetImage = {
          width: realImage.width,
          height: realImage.height,
        };
        realImage = null;
      } else {
        targetImage = {
          width: videoPosterModel.getMetadata('width'),
          height: videoPosterModel.getMetadata('height'),
        };
      }

      const agd = videoPosterModel.get('agd');
      if (!_.isEmpty(agd)) {
        const poster = {
          x: agd.cropX,
          y: agd.cropY,
          x1: agd.cropX1,
          y1: agd.cropY1,
        };

        const selection = {
          width: targetImage.width * poster.x1 - targetImage.width * poster.x,
          height:
            targetImage.height * poster.y1 - targetImage.height * poster.y,
        };

        const shift = {
          x: container.width / selection.width,
          y: container.height / selection.height,
        };
        const cssContext = {
          width: Math.round(shift.x * targetImage.width) + 'px',
          'max-width': Math.round(shift.x * targetImage.width) + 'px',
          height: Math.round(shift.y * targetImage.height) + 'px',
          marginLeft:
            '-' + Math.round(shift.x * (targetImage.width * poster.x)) + 'px',
          marginTop:
            '-' + Math.round(shift.y * (targetImage.height * poster.y)) + 'px',
        };
        $img.css(cssContext);
      }
    }
  },

  _getModalStoryMetadataDetailsContext: function () {
    return { backdrop: false, keyboard: true, show: true };
  },
  _getModalStoryMetadataEditorContext: function () {
    return { backdrop: true, keyboard: false, show: true };
    // return { backdrop: false, keyboard: true, show: true };
  },
  _getStoryMetadataContext: function () {
    const categories = _.cloneDeep(tk.context.storyCategories).map((o) => {
      return {
        id: o.categoryId,
        label: o.categoryLabel,
      };
    });
    categories.unshift({ id: null, label: 'Choose a Category' });

    const context = {
      _languagesList: tk.context.languages.map((o) => {
        return {
          id: o.value,
          label: o.text,
        };
      }),
      _categoriesList: categories,
      _wochitYoutubeChannels: tk.context.wochitYoutubeChannels,
      _manualYoutubeChannelSelection: this._bmanualYoutubeChannelSelection,
    };

    const storyBrand =
      app.rootStore.getters['user/selectedOrganization'].brands.find(
        (brand) =>
          brand.brandId === this.model.get('brandId') &&
          brand.programmerId === this.model.get('programmerId')
      ) || null;

    context._storyBrandName = storyBrand ? storyBrand.name : '(obsolete)';

    return context;
  },

  _showManual: function () {
    this.viewState.set('displayState', this.DISPLAY_STATE.EDITOR);
    storyViewBus.$emit('svbPauseRcp');
    this.show();
  },

  show: function (options) {
    this.render(
      $.extend(
        {
          displayState: this.viewState.get('displayState'),
          _isStoryboard: !!this.model.get('template'),
        },
        options
      )
    );
    this._showModal();
  },
  _showModal: function () {
    if (!this.modalCreated) {
      this.modalCreated = true;
      this.$storyMetadataEditor.modal(
        this._getModalStoryMetadataEditorContext()
      );
    }
    this._renderPoster();

    const isMac = navigator.platform === 'MacIntel';
    const metaProp = isMac ? 'metaKey' : 'ctrlKey';
    const handlers = [
      {
        on: 'keydown',
        key: $.ui.keyCode.ESCAPE,
        inEditor: true,
        run: this._hideMeta.bind(this),
      },
      // prevent undo-redo
      { on: 'keydown', key: 90 /* Z*/, run: _.noop, [metaProp]: true },
      {
        on: 'keydown',
        key: 90 /* Z*/,
        run: _.noop,
        [metaProp]: true,
        shiftKey: true,
      },
      // prevent timeline zoom
      { on: 'keyup', key: 187 /* plus*/, run: _.noop },
      { on: 'keyup', key: 189 /* minus*/, run: _.noop },
    ];

    if (!isMac) {
      handlers.push({
        on: 'keydown',
        key: 89 /* Y*/,
        run: _.noop,
        ctrlKey: true,
      });
    }

    if (app.keyboardAccessibility.isUnique(app.KEYBOARD_LAYER.MDE)) {
      app.keyboardAccessibility.add(app.KEYBOARD_LAYER.MDE, handlers);
    }
  },
  _destroyCustomVideoSettingsView: function () {
    if (this.customVideoSettingsView) {
      this.customVideoSettingsView.$destroy();
      this.customVideoSettingsView.$el.remove();
      this.customVideoSettingsView = null;
    }
  },
  _destroyCategoriesManager: function () {
    if (this.categoriesManagerVue) {
      this.categoriesManagerVue.$destroy();
      this.categoriesManagerVue.$el.remove();
      this.categoriesManagerVue = null;
    }
  },
  _hideMeta: function (options) {
    this._destroyCustomVideoSettingsView();
    if (this.categoriesManagerVue) {
      const $categoriesEl = this.$el.find('#storyboardCategoriesManager');
      this._destroyCategoriesManager();
      $categoriesEl?.removeClass('-block -visible');
    }
    if (this.categoriesVue) {
      this.categoriesVue.$destroy();
      this.categoriesVue.$el.remove();
      this.categoriesVue = null;
    }
    app.keyboardAccessibility.remove(app.KEYBOARD_LAYER.MDE);
    options = $.extend({ autoProduce: false }, options);
    this.$storyMetadataEditor.modal('hide');
    const $backdrop = $('.modal-backdrop.in');
    if ($backdrop && _.isElement($backdrop[0])) {
      $backdrop.remove();
    }
    this.modalCreated = false;
    if (options.autoProduce) {
      this.controller.previewStory();
    }
  },

  isModelchanged: function () {
    const newFields = this._getStoryNewFields();
    for (const field in newFields) {
      if (!_.isEqual(this.model.get(field), newFields[field])) {
        return true;
      }
    }

    if (
      !_.isEqual(
        this.videoPosterModelWorkingCopy.attributes,
        this.model.videoPosterModel.attributes
      )
    ) {
      return true;
    }

    return false;
  },
  _cancelRevert: function () {
    this.$storyMetadataEditorAreYouSure.modal('hide');
    this.$storyMetadataEditor.modal('show');
  },
  _confirmRevert: function () {
    this.$storyMetadataEditorAreYouSure.modal('hide');
    console.log('REVERT !!!');
  },
  /**
   * Render task view inner html (yet being DOM-detached)
   *
   * @returns {$el}, html
   */
  // TODO 6.0.0 you're not suppose to override Marionette's render method!
  render: function (options) {
    const programmer = this.model.getProgrammer();
    this.originalTitle = this.model.get('title');
    this.videoPosterModelWorkingCopy =
      new this.model.videoPosterModel.constructor(
        this.model.videoPosterModel.attributes
      );

    this._bmanualYoutubeChannelSelection =
      programmer && programmer.get('manualYoutubeChannelSelection');
    const context = $.extend(
      {},
      this.model.attributes,
      this._getStoryMetadataContext(),
      options
    );

    console.log('storyMetadataView -> render', this.$el, context);
    // this.$el.html(this.template(context));
    try {
      const html = this.template(context);

      // Log when empty renders occur
      if (!html || html.trim() === '') {
        throw new Error(
          `Empty template render detected: templateId: storyMetadataEditor, context: ${JSON.stringify(
            context
          )}`
        );
      }

      this.$el.html(html);
    } catch (error) {
      console.error('Template render error:', error, {
        templateId: 'storyMetadataEditor',
        context: JSON.stringify(context),
      });
      const errorOptions = {
        templateId: 'storyMetadataEditor',
        context: JSON.stringify(context),
        renderFailed: true,
      };

      app.doctorController.report(
        'storyMetadataView render error',
        error,
        errorOptions
      );
    }
    this.$storyMetadataEditor = this.$el.find('#storyMetadataEditor-Edit');
    this.$storyMetadataEditorAreYouSure = this.$el.find(
      '#storyMetadataEditor-AreYouSure'
    );
    this.$storyMetadataEditorTumbnail = this.$el.find(
      '#storyMetadataEditor-Tumbnail'
    );
    this.$storyMetadataEditorEditContainer = this.$el.find(
      '#storyMetadataEditor-EditContainer'
    );
    this.$videoPosterContainer = this.$el.find('.js-image-container');
    this.$info = this.$el.find('.js-info-alt');
    this.$editPoster = this.$el.find('.js-edit-poster');

    const noSelectedAssets = _.isEmpty(app.rootStore.getters.selectedAssets);

    this.$editPoster.toggleClass('-disabled', noSelectedAssets);

    if (noSelectedAssets) {
      this.$editPoster.not('.js-image-container').tooltip({
        placement: 'top',
        container: '.wt-body',
        delay: 25,
        title: app.culture.get('tooltip.CHOOSE_DISABLE_TOOLTIP'),
        trigger: 'hover',
        template:
          '<div class="tooltip wt-preset-tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
      });
    }

    this._addSubviews();
    // elements
    this.$title = this.$el.find('input[data-name="title"]');
    this.$title.on('input', (e) => {
      const value = e.currentTarget.value;
      if (value) {
        $(e.currentTarget).parent().removeClass('error');
        $(e.currentTarget).next('.field-error').hide();
      }
    });
    this.$description = this.$el.find('textarea[data-name="description"]');
    this.$ddlYoutubeChannel = this.$el.find('#ddlYoutubeChannel');
    this.$category = this.$el.find('#mainCategory');
    this.$category.change(this._onChange);
    this.$ddlLanguage = this.$el.find('#ddlLanguage');
    this.$ddlLanguage.change(this._onChange);

    // show only to WOCHIT_OPS
    if (app.rootStore.getters['user/type'].WOCHIT_OPS) {
      this.$el.find('.excellent-article').show();
    } else {
      this.$el.find('.excellent-article').hide();
    }
    this._clearDisplayedError();

    const $elCategories = $('#storyboardCategories .-container');
    if (this.model.get('template') && $.isElement($elCategories)) {
      const selectedCategories = {};
      _.each(this.model.get('_categoryIds'), (category) => {
        selectedCategories[category] = true;
      });

      this.categoriesVue = new StoryboardCategoriesList({
        el: '#storyboardCategories .-container',
        data: {
          selectedCategories,
        },
      });

      this.categoriesVue.$on('showTopicManager', (value) => {
        if (this.categoriesManagerVue) {
          return;
        }
        this.categoriesManagerVue = new CategoriesManager({
          el: '#storyboardCategoriesManager .-container',
          propsData: {
            showCloseIcon: true,
          },
        });
        this.$el.find('#storyboardCategoriesManager').addClass('-block');
        setTimeout(() => {
          this.$el.find('#storyboardCategoriesManager').addClass('-visible');
        }, 0);
        this.categoriesManagerVue.$on('new', ({ id }) => {
          app.Vue.set(this.categoriesVue?.selectedCategories, id, true);
        });
        this.categoriesManagerVue.$on('delete', (categoryId) => {
          const storyCategoryIds = this.model.get('_categoryIds');
          const index = storyCategoryIds.indexOf(categoryId);
          if (index > -1) {
            storyCategoryIds.splice(index, 1);
            this.model.set('_categoryIds', storyCategoryIds);
            if (
              this.categoriesVue &&
              this.categoriesVue.selectedCategories?.length
            ) {
              this.categoriesVue.selectedCategories =
                this.categoriesVue.selectedCategories.filter(
                  (category) => category.id !== categoryId
                );
            }
          }
        });
        this.categoriesManagerVue.$on('close', () => {
          const $categoriesEl = this.$el.find('#storyboardCategoriesManager');
          $categoriesEl?.removeClass('-visible');
          setTimeout(() => {
            this._destroyCategoriesManager();
            $categoriesEl?.removeClass('-block');
            $categoriesEl.append('<div class="-container"/>');
          }, 200);
        });
      });
    }

    return this.$el;
  },

  _renderImageContainer: function () {
    if ($.isElement(this.$videoPosterContainer)) {
      const parentWidth = this.$videoPosterContainer.parent().width();
      const newWidth =
        this.$videoPosterContainer.height() *
        this.model.get('_aspectRatio').ratio;
      this.$videoPosterContainer.width(newWidth);
      const margin = (parentWidth - newWidth) / 2;
      this.$videoPosterContainer.css('margin-left', margin);
    }
  },

  _renderPoster: function () {
    if (this.model.videoPosterModel) {
      // set video poster when returning from previewing other tasks
      this._renderVideoPosterModel();
    }
  },
  _addSubviews: function () {
    if (this.TopicsView) {
      this.TopicsView.close();
    }

    this.TopicsView = new TopicsView({
      el: this.$el.find('#topicsView'),
      model: this.model,
    });

    this.TopicsView.render();
    this.$el.find('[data-name="seoTags"]').html(this.TopicsView.$el);
    this.TopicsView.domReady();

    if (this.model.get('publishedDate')) {
      if (this.editDateView) {
        this.editDateView.close();
      }
      this.editDateView = new EditDateView({
        model: this.model,
        date: this.model.get('publishedDate'),
        renderPublishDate: this.model.get('renderPublishDate'),
      });
      this.$el.find('.date-placeholder').html(this.editDateView.render());
      this.editDateView.domReady();
    }
  },

  /**
   * Execute additional DOM related initialization when task view markup is attached to the DOM
   */
  domReady: function () {},
  _clearDisplayedError: function () {
    this.$storyMetadataEditor.find('.field-error').hide();
    this.$el.find('.line-error').hide();
  },
  _changeTitle: function (e) {
    if (e.target.value.trim().length > 0) {
      $($(e.target).parents('p.row-fluid')[0]).removeClass('error');
      this.model.set('title', e.target.value.trim());
    }
  },
  _changeLanguage: function (e) {
    if (e.target.value.length > 0) {
      app.rootStore.commit('user/editorDefault', {
        language: e.target.value,
      });
    }
  },

  _getStoryNewFields: function () {
    const editorDefault = app.rootStore.getters['user/editorDefault'];
    let renderPublishDate = true;
    if (editorDefault.renderPublishDate) {
      if (editorDefault.renderPublishDate == 'true') {
        renderPublishDate = false;
      }
    }
    const publishedDate = this.editDateView
      ? this.editDateView.getDate()
      : null;
    let attributedBy = this.$('#inputAttributedBy').val();
    attributedBy = attributedBy || null;
    let seoTags = this.TopicsView.toJSON().seoTags;
    seoTags = seoTags || [];
    const result = {
      title: this.$title.val().trim(),
      description: this.$description.val(),
      // narratedText:this._getNarratedText(),
      attributedBy,
      publishedDate: publishedDate,
      renderPublishDate: renderPublishDate,
      seoTags,
    };

    const $mainCategory = this.$('#mainCategory');
    if ($.isElement($mainCategory)) {
      const tid = $mainCategory.val();
      if (_.isDefined(tid)) {
        Object.assign(result, {
          topicId: tid,
        });
      }
    }

    const $ddlLanguage = this.$('#ddlLanguage');
    if ($.isElement($ddlLanguage)) {
      const storyLanguage = $ddlLanguage.val();
      if (_.isDefined(storyLanguage)) {
        Object.assign(result, {
          storyLanguage,
        });
      }
    }

    const programmer = this.model.getProgrammer();
    if (programmer && programmer.get('manualYoutubeChannelSelection')) {
      result.youtubeChannelUID = this.$('#ddlYoutubeChannel').val();
    }
    if (this.categoriesVue) {
      let categories = Object.keys(this.categoriesVue.selectedCategories);
      categories = categories.filter(
        (c) => this.categoriesVue.selectedCategories[c]
      );
      result._categoryIds = categories;
    }
    return result;
  },
  _editorApply: function () {
    if (!this.isValid()) {
      return false;
    }

    let resetTimelineRTPs = false;

    if (this.videoCustomoverlaysUpdates.size) {
      const customOverlays =
        _.cloneDeep(this.model.get('customOverlays')) || [];
      this.videoCustomoverlaysUpdates.forEach((customOverlayField) => {
        const customOverlay = customOverlays.find(
          (co) => co.id === customOverlayField.customOverlayId
        );
        if (customOverlay) {
          if (!customOverlay.noRealtimePreview) {
            resetTimelineRTPs = true;
          }
          const targetField = customOverlay.fields.find(
            (field) => field.name === customOverlayField.name
          );
          if (targetField) {
            targetField.value = customOverlayField.value;
          }
        }
      });
      this.model.set('customOverlays', customOverlays);
      this.model.invalidateFullPreview();
      this.model.hasBeenChanged();
    }

    if (this.isModelchanged()) {
      const newFields = this._getStoryNewFields();
      if (newFields.storyLanguage !== this.model.get('storyLanguage')) {
        resetTimelineRTPs = true;
      }
      this.model.set(newFields);
      this.model.videoPosterModel.set(
        this.videoPosterModelWorkingCopy.attributes
      );

      this.model.invalidateFullPreview();

      if (this.model.get('template')) {
        app.api.draftStoryTemplates
          .updateTemplateMetadata({
            storyId: this.model.get('id'),
            categoryIds: this.model.get('_categoryIds'),
            lockBgMusic: this.model.get('_lockBgMusic'),
            channelId: app.rootStore.state.user.channelId,
          })
          .then(() => {
            this.model.hasBeenChanged();
          });
      } else {
        this.model.hasBeenChanged();
      }
    }

    if (resetTimelineRTPs) {
      this.model.refreshTimelineRTPs();
    }

    this._hideMeta({
      autoProduce:
        this.viewState.get('displayState') === this.DISPLAY_STATE.PRODUCE,
    });
    return true;
  },
  /**
   * Validate entire task using business logic
   */
  isValid: function () {
    let isValid = true;
    if (this.viewState.get('displayState') === this.DISPLAY_STATE.PRODUCE) {
      return this.validateForProduce({ internalValid: true });
    } else if (
      this.$title &&
      this.$title.val().trim().length > app.MAX_TITLE_LENGTH
    ) {
      this.$title
        .parents('p')
        .find('span.error')
        .html(
          app.culture.generic.MAX_VIDEO_TITLE_EXCEEDS.format(
            app.MAX_TITLE_LENGTH
          )
        );
      this.$title.parents('p').addClass('error');
      this.$title.parents('p').find('span.error').show();
      isValid = false;
    } else {
      this.$title.parents('p').removeClass('error');
      this.$title.parents('p').find('span.error').hide();
    }
    return isValid;
  },

  _findSelectedCategory: function () {
    if (this.model.get('template')) {
      return;
    }
    const categoryId = this.model.get('topicId');
    const { storyCategories } = tk.context;
    const defaultCategory = _.find(storyCategories, {
      selectedByDefault: true,
    });
    let selectedCategory;

    if (categoryId) {
      selectedCategory = _.find(storyCategories, { categoryId });
      if (!selectedCategory) {
        selectedCategory = defaultCategory;
      }
    } else {
      selectedCategory = defaultCategory;
    }
    const tid = selectedCategory ? selectedCategory.categoryId : null;
    this.model.set({
      topicId: tid,
    });
  },

  _limitDescription: function (e) {
    const descVal = this.$description.val();
    const descLength = descVal.length;
    const limit = 5000;
    const remain = parseInt(limit - descLength);

    if (remain <= 0 && e.which !== 0 && e.charCode !== 0) {
      this.$description.val(descVal.substring(0, limit));
    }
  },

  /**
   * @return {Boolean}
   */
  validateForProduce: function (options = { internalValid: false }) {
    this._clearDisplayedError();

    const youtubeChannelUID = options.internalValid
      ? this.$('#ddlYoutubeChannel').val()
      : this.model.get('youtubeChannelUID');
    let title = options.internalValid
      ? this.$title.val().trim()
      : this.model.get('title');
    const isStoryboard = this.model.get('template');
    let categoryMissing = false;
    if (isStoryboard) {
      categoryMissing = this.categoriesVue
        ? !Object.values(this.categoriesVue.selectedCategories).reduce(
            (bool, value) => bool || value,
            false
          )
        : _.isEmpty(this.model.get('_categoryIds'));
    } else {
      let tid = options.internalValid
        ? this.$('#mainCategory').val()
        : this.model.get('topicId');

      if (tid) {
        tid = String(tid);
      }

      categoryMissing = _.isEmpty(tid);
    }

    title = title || '';
    const titleMissing = _.isEmpty(title.replace(/\s/g, ''));
    if (options.internalValid) {
      this.model.get('_categoryIds');
    }
    const youtubeChannelMissing =
      this._bmanualYoutubeChannelSelection &&
      _.isEmpty(youtubeChannelUID) &&
      !this.model.get('template');

    this.viewState.set('displayState', this.DISPLAY_STATE.PRODUCE);

    if (titleMissing || youtubeChannelMissing || categoryMissing) {
      !options.internalValid && this.show();

      if (titleMissing) {
        this.$title
          .parents('p.row')
          .addClass('error')
          .find('span.error')
          .html(app.culture.metadataEditor.missingTitle);
        this.$title.parents('p.row').find('span.error').show();
      }
      if (categoryMissing) {
        if (isStoryboard) {
          this.categoriesVue.error = true;
        } else {
          this.$category.parents('p.row').find('span.error').show();
        }
      }
      if (youtubeChannelMissing) {
        this.$ddlYoutubeChannel.parents('p.row').find('span.error').show();
      }

      this.$el.find('.line-error span.error').show();
      this.$el.find('.line-error').show();

      return false;
    }

    return true;
  },

  onBeforeDestroy: function () {
    this._hideMeta();
    this._destroyAiPromptsView();
    this.$info = null;
  },

  _modalOnShow: function () {
    this._destroyCustomVideoSettingsView();
    this._destroyAiPromptsView();

    const $elCustomVideoSettings = $('#customVideoSettings');
    if ($.isElement($elCustomVideoSettings)) {
      $elCustomVideoSettings.append('<div/>');
      this.customVideoSettingsView = new CustomVideoOverlays({
        store: app.rootStore,
        el: '#customVideoSettings div',
        propsData: {
          customOverlaysPresets:
            _.cloneDeep(this.model.getThemeInfo().storyPresets) || [],
          customOverlayValues:
            _.cloneDeep(this.model.get('customOverlays')) || [],
        },
      });
      this.customVideoSettingsView.$on('change', (customOverlayField) => {
        this.videoCustomoverlaysUpdates.set(
          `${customOverlayField.customOverlayId}_${customOverlayField.name}`,
          customOverlayField
        );
      });
    }

    const $elAiPrompts = $('#aiPromptsContainer');
    if ($.isElement($elAiPrompts)) {
      $elAiPrompts.append('<div/>');
      this.aiPromptsView = new (app.Vue.extend(AiPromptsList))({
        el: '#aiPromptsContainer div',
        propsData: {
          prompts: this.model.get('aiPrompts') || [],
        },
      });
    }
  },

  _destroyAiPromptsView: function () {
    if (this.aiPromptsView) {
      this.aiPromptsView.$destroy();
      this.aiPromptsView = null;
    }
  },
});

export default app.namespace.View.StoryMetadataView;
